// Components
import './header'
import './scrollbar'
import './other'

// Pages
import './pages/about/index'
import './pages/catalog'
import './pages/product'

window.onload = () => {
    console.log("loaded")
    // document.querySelector('#videoElement').play();
}
